<!--suppress CssUnusedSymbol, JSUnresolvedVariable, ES6ModulesDependencies -->
<template>
    <div class="pm-smart-treatment-item--settings" :class="$theme.defaultText">
        <div class="pm-smart-treatment-settings--slider-wrapper">
            <!--div v-if="activeTreatmentPid && typeof selectedRegion !== 'undefined'" style="background: #e8e8e8;" class="jaw-position-marker" :class="[$theme.jawRegionMarkerBg, 'jaw-position-marker-' + selectedRegion]"></div-->
            <div v-show="tabs.length > 0" class="pm-smart-treatment-settings--slider" @touchstart="onTouchStart" @touchend="onTouchEnd">
                <template v-for="regionId in [0, 2, 1, 3, 5, 4]">
                    <pm-treatment-settings-tooth
                        v-show="(regionId < 3 && selectedRegion < 3) || (regionId > 2 && selectedRegion > 2)"
                        :id="'pm-treatment-settings-toot-region-' + regionId"
                        :key="regionId"
                        :region-id="regionId"
                        :markers="markers"
                        :active-treatment-pid="activeTreatmentPid"
                        :selected-teeth="selectedTeeth"
                        :full-jaw="fullJaw"
                        :editable-teeth="editableTeeth"
                        @selectRegion="selectRegion"
                        @toggleSelection="toggleSelection"
                    />
                </template>
            </div>
        </div>

        <div :key="activeTreatmentPid" style="margin: 0 0 0 0" class="pm-smart-treatment-item--tab-wrapper">
            <template v-for="(id, i) in tabs">
                <span v-if="i>0"> + </span>
                <span :id="'pm-smart-treatment-item--tab-' + id"
                      style="display: inline-block; margin: 0 12px 8px 12px;"
                      class="pm-smart-treatment-item--tab roboto bold--text f13"
                      :style="id === activeTreatmentPid ? `color: ${fullJaw ? '#2862e6' : '#d24574'}` : 'color: #B8BABE'"
                      @click="selectTab(id)"
                >{{ counters[String(id)] }} {{ $t('plan_calculator.state_' + id) }}
                    <v-icon v-if="fullJaw && ([10,11].includes(id) || (editableTeeth && editableTeeth.length === 0))" style="font-size: 14px; margin-top: -4px;">lock_outline</v-icon>
                </span>
            </template>
        </div>
    </div>
</template>

<style lang="scss">
    .pm-smart-treatment-settings--slider {
        flex-direction: row;
        font-family: sans-serif;
        scroll-snap-type: x mandatory;
        display: flex;
        -webkit-overflow-scrolling: touch;
	    overflow-x: scroll;
    }
    .pm-smart-treatment-settings--slider::-webkit-scrollbar  {
        display: none;
        height: 0;
        width: 0;
    }

    .pm-smart-treatment-settings--slider-item {
        width: 100vw;
        height: 88px;
        scroll-snap-align: start;
        padding: 28px 0 0 0;
    }


    .animation-blinking {
        animation-name: blinker;
        animation-duration: .8s;
        animation-iteration-count: infinite;
    }
    @keyframes blinker {
        0% { opacity: 0; }
        50% { opacity: 1; }
        100% { opacity: 0; }
    }
    .pm-smart-treatment-item--settings--region-navigator {
        .v-btn.with-treatment {
             /* border: 2px solid #2862E6!important;*/
            .v-icon { color: #2862E6!important; }
            background: rgba(43, 55, 72, 0.06)!important;
            border: 2px solid rgba(43, 55, 72, 0.06)!important;
        }

        .v-btn.without-treatment {
            border: 2px solid rgba(43, 55, 72, 0.06)!important;
        }

        .v-btn--disabled {
            opacity: 0;
        }
    }

    .pm-smart-treatment-settings--slider-wrapper {
        height: 88px;
        overflow: hidden;
    }

     @media (min-width: 700px) {
            .pm-smart-treatment-item--settings {

            }
         .pm-smart-treatment-settings--slider-item,
         .pm-smart-treatment-settings--slider-wrapper {
             height: 98px;
         }
     }

    .pm-smart-treatment-item--settings {
        height: 130px;
        padding: 0 0 0 0;
        text-align: center;

        &--tooth-marker {
            &-top, &-bottom {
             line-height: 16px;
            font-size: 9px;
            left: 50%;
            margin-left: -8px;
            position: absolute;
            width: 16px;
            height: 16px;
            border-radius: 50%;
            }
            &-top {
                top: 0;
            }
            &-bottom {
                bottom: 0;
            }
        }

    }



    .pm-smart-treatment-item--settings .v-input .v-slider__ticks span {
        font-size: 10px!important;
    }

    .pm-smart-treatment-item--settings .v-slider__ticks-container .v-slider__ticks:first-child {
        margin-left: -6px;
    }
    .pm-smart-treatment-item--settings .v-slider__ticks-container>span:last-of-type {
        margin-left: 6px;
    }
    .pm-smart-treatment-item--settings .v-slider__thumb {
        width: 56px;
        height: 56px;
        left: -28px;
    }
    .pm-smart-treatment-item--settings .v-slider__thumb {
        background: rgba(0,0,0,.05)!important;
    }
    .pm-smart-treatment-item--settings .v-input--is-disabled .v-slider__thumb {
        display: none!important;
    }
    .pm-smart-treatment-item--settings .v-slider__thumb.primary:before {
        content: '';
        position: absolute;
        display: block;
        background: #2862E6;
        width: 12px;
        height: 12px;
        left: 22px;
        top: 22px;
        border-radius: 50%;
    }
    .pm-smart-treatment-item--settings .v-slider__ticks-container {
        margin-top: 10px;
    }

    .pm-smart-treatment-item--settings .v-input .v-slider__ticks span {
        font-size: 10px!important;
    }

    .pm-smart-treatment-item--settings .v-slider__ticks-container .v-slider__ticks:first-child {
        margin-left: -6px;
    }
    .pm-smart-treatment-item--settings .v-slider__ticks-container>span:last-of-type {
        margin-left: 6px;
    }
    .pm-smart-treatment-item--settings .v-slider__thumb {
        width: 56px;
        height: 56px;
        left: -28px;
    }
    .pm-smart-treatment-item--settings .v-slider__thumb {
        background: rgba(0,0,0,.05)!important;
    }
    .pm-smart-treatment-item--settings .v-input--is-disabled .v-slider__thumb {
        display: none!important;
    }
    .pm-smart-treatment-item--settings .v-slider__thumb.primary:before {
        content: '';
        position: absolute;
        display: block;
        background: #2862E6;
        width: 12px;
        height: 12px;
        left: 22px;
        top: 22px;
        border-radius: 50%;
    }
    .pm-smart-treatment-item--settings .v-slider__ticks-container {
        margin-top: 10px;
    }



    .jaw-position-marker {
        position: absolute;
        width: 23vw;
        height: 6px;
        border-radius: 3px;
        transition: all .5s;
    }
    .jaw-position-marker-0 {
        left: 10vw;
        top: 5px;
    }
    .jaw-position-marker-1 {
        left: 67vw;
        top: 5px;
    }
    .jaw-position-marker-2 {
        left: 38vw;
        top: 5px;
    }
    .jaw-position-marker-3 {
        left: 10vw;
        /*bottom: 5px;*/
        top: 5px;
    }
    .jaw-position-marker-4 {
        left: 67vw;
        /*bottom: 5px;*/
        top: 5px;
    }
    .jaw-position-marker-5 {
        left: 38vw;
        /*bottom: 5px;*/
        top: 5px;
    }

@media (min-width: 700px) {
    .pm-smart-treatment-item--tab {
        margin-top: 3px !important;
        font-size: 18px;
    }
}
</style>

<script>

import PlanSimpleModifierService from "../../extensions/services/plan-simple-modifier-service";
import PlanSimpleStatusGenerator from "../../extensions/services/plan-simple-status-generator";
import PlanSimpleService from "../../extensions/services/plan-simple-service";
import PmTreatmentSettingsTooth from "./treatment-settings-tooth";

import { breakBridgesToParts } from "../../utils/dental";

export default {
    props: {
        selectedRegion: {
            type: Number,
        },
        steps: {
            type: Object,
        },
    },

    components: {
        PmTreatmentSettingsTooth,
    },

    data() {
        return ({
            scrolling: false,
            regionTeethIds: [],
            selectedTeeth: [],
            activeRegion: 0,
            activeTreatmentPid: 0,
            affectedSteps: [],
            tabs: [],
            fullJaw: false,
            bridgeUnits: 12,
            markers: {},
            counters: {
                "9": 0,
                "10": 0,
                "11": 0,
                "15": 0,
                "26": 0,
                "300": 0,
            },
            editableTeeth: [],
            preventedReload: false,
            scrollTimeout: null,
            prevScrollPosition: 0,
            scrollDirection: "",
            touched: false,
        });
    },

    computed: {
        teethIds() {
            const teethIdsUpper = [17, 16, 15, 14, 13, 12, 11, 21, 22, 23, 24, 25, 26, 27];
            const teethIdsLower = [47, 46, 45, 44, 43, 42, 41, 31, 32, 33, 34, 35, 36, 37];
            return (this.selectedRegion < 3) ? teethIdsUpper : teethIdsLower;
        },
    },

    watch: {
        steps() {
            if (this.preventedReload === true) return;
            this.getData();
            let primaryTreatment = 0;
            this.steps.forEach((step) => {
                if (step.primary === 1) primaryTreatment = parseInt(step.state_pid);
            });

            this.$nextTick(()=>{
                this.scrollToRegion(this.selectedRegion);
            });
        },
        selectedRegion(currentRegion, prevRegion) {
            this.getData();
            this.$nextTick(()=>{
                if (!this.scrolling) this.scrollToRegion(currentRegion, prevRegion);
            });
        },
    },

    created() {
        this.registerBusEvent('region-selector:select', (regionId) => {
            this.scrollToRegion(parseInt(regionId), parseInt(this.selectedRegion));
        });
    },

    activated() {
        this.$nextTick(()=>{
            if (!this.scrolling) this.scrollToRegion(this.selectedRegion);
        });
    },

    methods: {
        setSelectedRegion(region) {
            this.$nextTick(()=>{
                this.scrollToRegion(region, -1);
            });
        },
        preventReload() {
            this.preventedReload = true;
        },
        unpreventReload() {
            this.preventedReload = false;
        },
        scrollToRegion(currentRegion, prevRegion = -1) {
            const elmnt = document.querySelector(".pm-smart-treatment-settings--slider");
            let left = 0;
            const w = parseInt(window.innerWidth);
            if ([2, 5].includes(parseInt(currentRegion))) left = w;
            if ([1, 4].includes(parseInt(currentRegion))) left = 2 * w;
            let behavior = "smooth";
            if (prevRegion < 0) behavior = "auto";
            if (prevRegion < 3 && currentRegion >= 3) behavior = "auto";
            if (prevRegion >= 3 && currentRegion < 3) behavior = "auto";
            if (elmnt) {
                elmnt.scrollTo({
                    top: 0,
                    left: left,
                    behavior: behavior,
                });
            }
        },
        onTouchStart() {
            this.touched = true;
            if (this.scrollerTimeout) clearTimeout(this.scrollerTimeout);
            this.scrolling = true;
        },
        onTouchEnd() {
            this.touched = true;
            this.scrollerTimeout = window.setTimeout(()=>{
                this.scrolling = false;
                this.touched = false;
            }, 500);
        },
        selectRegion(regionId) {
            if (this.touched) this.$emit("selectRegion", regionId);
        },
        update() {
            this.getData();
        },

        getData() {
            this.tabs = this.getPrimaryTreatmentsForSelectedJaw();
            this.getCounters();
            this.$store.state.simplePlan.availableTreatmentPids = this.tabs;
            if (window.lastTplActiveTab && this.tabs.includes(window.lastTplActiveTab)) {
                this.selectTab(window.lastTplActiveTab);
                window.lastTplActiveTab = 0;
            }
            else if (!this.tabs.includes(this.activeTreatmentPid)) this.selectTab(this.tabs[0]);

            this.getSelectedTeeth();
            this.activeRegion = parseInt(this.selectedRegion);
            this.regionTeethIds = Helper.getRegionTeethIds(this.activeRegion);
            this.getMarkers();
            this.getJawRange();
            this.setEditableTeeth();
        },
        getCounters() {
            Object.keys(this.counters).forEach((key) => {
                this.counters[String(key)] = 0;
            });
            this.affectedSteps.forEach((step) => {
                if (!step.primary) return;
                if (step.tooth_id === "0" || step.tooth_id === "") return;
                this.counters[String(step.state_pid)] += step.tooth_id.split(",").length;
            });
        },
        getJawRange() {
            const jaw = this.selectedRegion < 3 ? "upper" : "lower";
            const range = PlanSimpleService.getJawRange(jaw);
            this.$set(this.$store.state.simplePlan.jawRange, 0, range[0]);
            this.$set(this.$store.state.simplePlan.jawRange, 1, range[1]);
        },

        getMarkers() {
            this.$store.state.simplePlan.treatedToothNumbers.splice(0, this.$store.state.simplePlan.treatedToothNumbers.length);
            this.regionTeethIds.forEach((toothId) => {
                toothId = String(toothId);
                this.markers[toothId] = {
                    crown: [],
                    root: [],
                };
                for (const i in this.steps) {
                    const step = this.steps[i];
                    if (step.primary !== 1) continue;
                    // if (!this.tabs.includes(parseInt(step.state_pid))) continue; // Step is non-primary
                    if (step.tooth_id.split(",").includes(toothId)) {
                        this.$store.state.simplePlan.treatedToothNumbers.push(parseInt(toothId));
                        if ([9, 15, 26, 300].includes(parseInt(step.state_pid))) this.markers[toothId].crown.push(parseInt(step.state_pid));
                        if ([7, 10, 11].includes(parseInt(step.state_pid))) this.markers[toothId].root.push(parseInt(step.state_pid));
                    }
                }
            });
        },

        getPrimaryTreatmentsForSelectedJaw() {
            const data = PlanSimpleService.getPrimaryStepsForJaw(this.$store.state.simplePlan.selectedJaw);
            this.affectedSteps.splice(0, this.affectedSteps.length);
            this.affectedSteps.push(...data.steps);
            return data.stateIds;
        },

        selectTab(id) {
            if (this.activeTreatmentPid !== id) {
                id = parseInt(id);
            }
            this.activeTreatmentPid = id;
            this.getSelectedTeeth();
            this.$store.state.simplePlan.activeTreatmentPid = id;
            this.setEditableTeeth();
        },

        setEditableTeeth() {
            this.affectedSteps.forEach((step) => {
                if (parseInt(step.state_pid) === this.activeTreatmentPid && step.fullJaw) {
                    if (typeof step.editable === "undefined") this.editableTeeth = null;
                    else this.editableTeeth = step.editable;
                }
            });
        },

        isToothEditable(toothId) {
            if (!this.fullJaw) return true;
            if (this.fullJaw && !this.editableTeeth) return false;
            if (this.editableTeeth === null) return true;
            const id = parseInt(toothId) % 10;
            return this.editableTeeth.includes(id);
        },

        validateSelection(toothId) {
            if (!this.isToothEditable(toothId)) {
                this.$bus.$emit("app.showSnackbar", {text: this.editableTeeth === null ? this.$t("plan_simple.not_editable_" + this.activeTreatmentPid) : this.$t("plan_simple.editable_" + this.activeTreatmentPid + "_"+ this.editableTeeth.join("_"))});
                return false;
            }

            let veneerIds = this.getTeethWithTreatment(26);

            if (veneerIds.includes(toothId) && this.activeTreatmentPid !== 26) {
                this.$store.state.simplePlan.blinkingToothId = parseInt(toothId);
                window.setTimeout(()=>{
                    this.$store.state.simplePlan.blinkingToothId = 0;
                }, 3 * 800);
                return false;
            }

            if ([9, 15, 26].includes(this.activeTreatmentPid) && !this.selectedTeeth.includes(toothId)) {
                const crownIds = this.getTeethWithTreatment(9);
                const bridgeIds = this.getTeethWithTreatment(15);
                const veneerIds = this.getTeethWithTreatment(26);
                if (crownIds.includes(toothId) || bridgeIds.includes(toothId) || veneerIds.includes(toothId)) {
                    this.$store.state.simplePlan.blinkingToothId = parseInt(toothId);
                    window.setTimeout(()=>{
                        this.$store.state.simplePlan.blinkingToothId = 0;
                    }, 3 * 800);
                    return false;
                }
            }
            return true;
        },

        toggleSelection(toothId) {
            toothId = String(toothId);

            // Prevent adding locked/concurrent treatment
            if (!this.validateSelection(toothId)) return;

            if (this.selectedTeeth.includes(toothId)) this.toggleSelectionRemove(toothId);
            else this.toggleSelectionAdd(toothId);

            if (this.fullJaw) this.toggleSelectionFullJaw(toothId);

            this.getMarkers();
            this.getCounters();
            this.getJawRange();
            this.$store.state.simplePlan.activeToothNumbers = this.selectedTeeth;
            const jaw = this.selectedRegion < 3 ? "upper" : "lower";
            this.$set(this.$store.state.simplePlan, jaw+"JawTotal", this.$store.getters["simplePlan/totalForJaw"](jaw, true));
            PlanSimpleStatusGenerator.addStatus([], jaw, null, this.steps);
            this.$emit("updated");
        },


        getCounterByTpl(tpl, statePid) {
            let counter = 0;
            this.affectedSteps.forEach((step) => {
                if (!step.primary) return;
                if (step.tooth_id === "0" || step.tooth_id === "") return;
                if (step.tpl !== tpl) return;
                if (parseInt(step.state_pid) !== parseInt(statePid)) return;
                counter += step.tooth_id.split(",").length;
            });
            return counter;
        },

        getNearestSiblings(toothId, stateId) {
            const ids = this.getTeethWithTreatment(parseInt(stateId));
            let minDistance = 32;
            let siblings = [];

            ids.forEach((id) => {
                const d = Helper.getTeethCountBetween([id, toothId]);
                if (d > minDistance) return;
                siblings = d === minDistance ? [...siblings, id]: [id];
                minDistance = d;
            })

            return siblings;
        },

        isSiblingWithImplant(toothId, stateId) {
            const siblings = this.getNearestSiblings(toothId, stateId);
            let implantIds = this.getTeethWithTreatment(11);

            if (siblings.length === 0) return false;

            if (siblings.length === 1) return implantIds.includes(siblings[0]);

            if (siblings.length === 2 && (implantIds.includes(siblings[0]) || implantIds.includes(siblings[1]))) {
                return typeof(window.latestSmartTreatment !== 'undefined') && window.latestSmartTreatment.includes('implant');
            }
            return false;
            // Window.latestSmartTreatment = item;
        },

        toggleSelectionAdd(toothId) {
            this.selectedTeeth.push(toothId);

            let crownIds = this.getTeethWithTreatment(9);
            let bridgeIds = this.getTeethWithTreatment(15);
            let implantIds = this.getTeethWithTreatment(11);
            let implantIdsOnePhase = this.getTeethWithTreatment(10);

            if (!this.fullJaw) {
                this.removeAllFromTooth(toothId);
            }

            if (this.fullJaw) {
                this.addTreatmentToTooth(toothId, this.activeTreatmentPid);
            } else {
                let activeTreatmentPid = parseInt(this.activeTreatmentPid);

                //toggleSelectionAdd(toothId, activeTreatmentPid, this.steps);
                //return;

                // Add implant if same amount of implants and crowns found
                // @TODO hadle treatment type to prevent add implant+bridde, crown, crown aut implant error
                if (activeTreatmentPid === 9 && this.counters["9"] === (this.getCounterByTpl('crown_implants', 11) + this.getCounterByTpl('crown_implants_one_phase', 11))) {
                    this.addTreatmentToTooth(toothId, 11);
                    implantIds = this.getTeethWithTreatment(11);
                }

                // Add base treatments
                if (activeTreatmentPid === 9) {
                    if (implantIds.includes(toothId)) {
                        // Add crown on implant
                        this.addTreatmentToTooth(toothId, this.activeTreatmentPid, 'crown_implants') ||
                        this.addTreatmentToTooth(toothId, this.activeTreatmentPid, 'crown_implants_one_phase') ||
                        this.addTreatmentToTooth(toothId, this.activeTreatmentPid, 'crown');
                    }
                    else if (this.isSiblingWithImplant(toothId, 9)) {
                        // Check the nearest / latest, add crown + optionally implant
                        this.addTreatmentToTooth(toothId, 11);
                        implantIds = this.getTeethWithTreatment(11);
                        this.addTreatmentToTooth(toothId, this.activeTreatmentPid, 'crown_implants') ||
                        this.addTreatmentToTooth(toothId, this.activeTreatmentPid, 'crown_implants_one_phase') ||
                        this.addTreatmentToTooth(toothId, this.activeTreatmentPid, 'crown');
                    } else {
                        this.addTreatmentToTooth(toothId, this.activeTreatmentPid, 'crown') ||
                        this.addTreatmentToTooth(toothId, this.activeTreatmentPid, 'crown_implants') ||
                        this.addTreatmentToTooth(toothId, this.activeTreatmentPid, 'crown_implants_one_phase');
                    }
                } else if (activeTreatmentPid === 15) {
                    if (this.counters["15"] === this.getCounterByTpl('bridge_implants', 15) || this.counters["15"] === this.getCounterByTpl('bridge_implants_one_phase', 15)) {
                        this.addTreatmentToTooth(toothId, this.activeTreatmentPid, 'bridge_implants') ||
                        this.addTreatmentToTooth(toothId, this.activeTreatmentPid, 'bridge_implants_one_phase') ||
                        this.addTreatmentToTooth(toothId, this.activeTreatmentPid, 'bridge');
                        this.autoAddImplant(this.selectedTeeth, toothId, true); // @TODO: handle if only implant bridge added and adding bridge to full different side
                    }
                    else if (this.isSiblingWithImplant(toothId, 15)) {
                        // Check the nearest / latest, add crown + optionally implant
                        this.addTreatmentToTooth(toothId, this.activeTreatmentPid, 'bridge_implants') ||
                        this.addTreatmentToTooth(toothId, this.activeTreatmentPid, 'bridge_implants_one_phase') ||
                        this.addTreatmentToTooth(toothId, this.activeTreatmentPid, 'bridge');
                        this.addTreatmentToTooth(toothId, 11);
                        implantIds = this.getTeethWithTreatment(11);
                        this.autoAddImplant(this.selectedTeeth, toothId, true);
                    }
                    else {
                        this.addTreatmentToTooth(toothId, this.activeTreatmentPid, 'bridge');
                    }
                } else {
                    this.addTreatmentToTooth(toothId, this.activeTreatmentPid);
                }

                // Add crowns on added implants
                // if (!this.fullJaw && this.activeTreatmentPid === 11) this.addCrownToTooth(toothId);
                if (activeTreatmentPid === 11) {
                    if (crownIds.includes(toothId)) {
                        this.addTreatmentToTooth(toothId, 9, 'crown_implants') ||
                        this.addTreatmentToTooth(toothId, 9, 'crown_implants_one_phase') ||
                        this.addTreatmentToTooth(toothId, 9, 'crown');
                    }
                    else if (bridgeIds.includes(toothId)) {
                        this.addTreatmentToTooth(toothId, 15, 'bridge_implants') ||
                        this.addTreatmentToTooth(toothId, 15, 'bridge_implants_one_phase') ||
                        this.addTreatmentToTooth(toothId, 15, 'bridge');
                    }
                    else {
                        this.addCrownToTooth(toothId);
                    }
                }

                // @TODO: remove preparation/crown from animation if no tooth id present
            }
            // this.autoAddImplant(this.selectedTeeth, toothId, true);
        },

        toggleSelectionRemove(toothId) {
            // @TODO: BUG - Bridge with implants -> bridge -> remove last tooth -> pillars become implants

            // Collect steps affected by deletion
            let deletionAffectedSteps = this.steps.filter(step => {
                if (!step.primary) return false;
                const tIds = step.tooth_id.split(",");
                return tIds.includes(String(toothId));
            });

            this.selectedTeeth.splice(this.selectedTeeth.indexOf(toothId), 1);
            this.removeTreatmentFromTooth(toothId, this.activeTreatmentPid);
            // if (!this.fullJaw && this.activeTreatmentPid === 11) this.removeCrownFromTooth(toothId);
            if (!this.fullJaw) {

                let crownIds = this.getTeethWithTreatment(9);
                let bridgeIds = this.getTeethWithTreatment(15);
                let implantIds = this.getTeethWithTreatment(11);

                this.removeAllFromTooth(toothId);
                if (crownIds.includes(toothId)) {
                    this.addTreatmentToTooth(toothId, 9, 'crown_implants') ||
                    this.addTreatmentToTooth(toothId, 9, 'crown_implants_one_phase') ||
                    this.addTreatmentToTooth(toothId, 9, 'crown');
                }
                else if (bridgeIds.includes(toothId)) {
                    this.addTreatmentToTooth(toothId, 15, 'bridge_implants') ||
                    this.addTreatmentToTooth(toothId, 15, 'bridge_implants_one_phase') ||
                    this.addTreatmentToTooth(toothId, 15, 'bridge');
                }

                // Check if implant position recalculation needed
                let implantBridgeIds = [];
                deletionAffectedSteps.forEach((s)=>{
                    if (s.state_id === 15 && (s.tpl==="bridge_implants" || s.tpl==="bridge_implants_one_phase")) implantBridgeIds.push(...s.tooth_id.split(","));
                });
                implantBridgeIds = implantBridgeIds.filter(id => !isNaN(parseInt(id)) && parseInt(id) > 0);

                if (implantBridgeIds.length > 0) {
                    const parts = PlanSimpleModifierService.breakToParts(Helper.sortToothNumbers(implantBridgeIds));
                    parts.forEach((part) => {
                        this.autoAddImplant(part, part[0]);
                    });
                }
            }
        },

        toggleSelectionFullJaw(toothId) {
            if (parseInt(toothId)%10 === 7) {
                const prevToothId = String(parseInt(toothId)-1);
                if (this.selectedTeeth.includes(toothId) && !this.selectedTeeth.includes(prevToothId)) {
                    this.selectedTeeth.push(prevToothId);
                    this.addTreatmentToTooth(prevToothId, this.activeTreatmentPid);
                }
            }

            if (parseInt(toothId)%10 === 6) {
                const prevToothId = String(parseInt(toothId)+1);
                if (!this.selectedTeeth.includes(toothId) && this.selectedTeeth.includes(prevToothId)) {
                    this.selectedTeeth.splice(this.selectedTeeth.indexOf(prevToothId), 1);
                    this.removeTreatmentFromTooth(prevToothId, this.activeTreatmentPid);
                }
            }
        },

        addCrownToTooth(toothId) {
            // return;
            let crownIds = this.getTeethWithTreatment(9);
            let bridgeIds = this.getTeethWithTreatment(15);

            if (crownIds.includes(toothId) || bridgeIds.includes(toothId) || crownIds.includes(String(toothId)) || bridgeIds.includes(String(toothId))) return;

            if (crownIds.length > 0 || bridgeIds.length === 0) {
                this.addTreatmentToTooth(toothId, 9, 'crown_implants') ||
                this.addTreatmentToTooth(toothId, 9, 'crown_implants_one_phase') ||
                this.addTreatmentToTooth(toothId, 9, 'bridge_implants') ||
                this.addTreatmentToTooth(toothId, 9, 'bridge_implants_one_phase') ||
                this.addTreatmentToTooth(toothId, 9, 'crown') ||
                this.addTreatmentToTooth(toothId, 9, 'bridge');
                return;
            } else {
                bridgeIds.push(toothId);
                bridgeIds = Helper.sortToothNumbers(bridgeIds);
                this.addTreatmentToTooth(toothId, 15, 'bridge_implants') ||
                this.addTreatmentToTooth(toothId, 15, 'bridge_implants_one_phase') ||
                this.addTreatmentToTooth(toothId, 9, 'crown_implants') ||
                this.addTreatmentToTooth(toothId, 9, 'crown_implants_one_phase') ||
                this.addTreatmentToTooth(toothId, 9, 'bridge') ||
                this.addTreatmentToTooth(toothId, 9, 'crown');
            }
        },

        removeTreatmentFromTooth(toothId, treatmentId) {
            toothId = String(toothId);
            treatmentId = parseInt(treatmentId);
            const jaw = this.selectedRegion < 3 ? "upper" : "lower";
            this.steps.forEach((step) => {
                if (step.jaw !== jaw) return;
                if (!step.update_with.includes(treatmentId)) return;
                const tIds = step.tooth_id.split(",");
                if (!tIds.includes(toothId)) return;
                tIds.splice(tIds.indexOf(toothId), 1);
                Helper.updateStepToothIds(step, tIds);
            });
        },

        addTreatmentToTooth(toothId, treatmentId, tpl = null) {
            toothId = String(toothId);
            treatmentId = parseInt(treatmentId);
            const jaw = this.selectedRegion < 3 ? "upper" : "lower";
            let added = false;
            this.steps.forEach((step) => {
                // if (added) return;
                if (step.jaw !== jaw) return;
                if (!step.update_with.includes(treatmentId)) return;

                if (tpl && step.tpl !== tpl) return;
                // if (treatmentId === 9 && this.hasStepWithTpl('crown') && step.tpl !== 'crown') return;

                let tIds = step.tooth_id.split(",");
                if (tIds.includes(toothId)) return;
                tIds.push(toothId);
                tIds = Helper.sortToothNumbers(tIds);
                Helper.updateStepToothIds(step, tIds);
                added = true;
            });
            return added;
        },

        hasStepWithTpl(tpl) {
            for (let i=0; i<this.steps.length; i++) {
                if (this.steps[i].tpl === tpl) return true;
            }
            return false;
        },

        removeAllFromTooth(toothId) {
            toothId = String(toothId);
            const jaw = this.selectedRegion < 3 ? "upper" : "lower";
            this.steps.forEach((step) => {
                if (step.jaw !== jaw) return;
                let tIds = step.tooth_id.split(",");
                if (!tIds.includes(toothId)) return;
                tIds.splice(tIds.indexOf(toothId), 1);
                if (tIds.length === 0) tIds = ["0"];
                Helper.updateStepToothIds(step, tIds);
            });
        },

        checkImplantBasePosition(part, toothId) {
            let implantIds = this.getTeethWithTreatment(11);
            return (implantIds.includes(part[0]) && implantIds.includes(part[part.length-1]));
        },

        autoAddImplant(selection, toothId, added = false) {
            if (parseInt(this.activeTreatmentPid)!== 15) return;
            // const parts = PlanSimpleModifierService.breakToParts(Helper.sortToothNumbers(selection));
            const parts = breakBridgesToParts(Helper.sortToothNumbers(selection));
            // console.log('Parts', parts);

            // get part with current tooth
            const part = parts.filter((part)=>{
                return part.includes(String(toothId));
            });

            let implantIds = this.getTeethWithTreatment(11);

            const partWithoutAdded = part[0].filter((tId)=>{
                return parseInt(tId) !== parseInt(toothId);
            });

            const partHasImplant = part[0].filter((tId) => {
                return implantIds.includes(tId);
            });

            if (implantIds.length === 0 || partHasImplant.length === 0) {
                return;
            }

            // check if implants are in base pillar position
            if (added && !this.checkImplantBasePosition(partWithoutAdded, toothId)) {
                return;
            }

            implantIds = implantIds.filter((tId)=>{
                return !part[0].includes(tId);
            });

            const implants = PlanSimpleModifierService.getPillars(part[0]);

            let toothIds = implantIds.concat(implants);
            toothIds = Helper.sortToothNumbers(toothIds);
            [11, 12, 13, 199].forEach((stateId) => {
                // this.updateAffectedStepsWithState(stateId, toothIds);
                this.updateStepsWithState(stateId, toothIds);
            });
        },

        getSelectedTeeth() {
            this.selectedTeeth = this.getTeethWithTreatment(this.activeTreatmentPid);

            this.fullJaw = false;
            this.affectedSteps.forEach((step) => {
                if (step.fullJaw === 1) this.fullJaw = true;
            });

            this.$set(this.$store.state.simplePlan, "activeToothNumbers", this.selectedTeeth);
        },

        getTeethWithTreatment(treatmentId) {
            let selectedTeeth = [];
            this.affectedSteps.forEach((step) => {
                if (parseInt(step.state_pid) === treatmentId) {
                    const ids = step.tooth_id.split(",");
                    selectedTeeth.push(...ids);
                }
            });
            selectedTeeth = selectedTeeth.filter(id => !isNaN(parseInt(id)) && parseInt(id) > 0);
            return selectedTeeth;
        },

        updateStepsWithState(statePid, selection) {
            selection = JSON.parse(JSON.stringify(selection));
            if (selection.length === 0) selection = ["0"];
            statePid = parseInt(statePid);
            const jaw = this.selectedRegion < 3 ? "upper" : "lower";

            this.steps.forEach((step) => {
                if (step.jaw !== jaw) return;
                if (parseInt(step.state_pid) !== statePid) return;
                Helper.updateStepToothIds(step, selection);
            });
        },
    },
};
</script>
